import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { trackFixedRateCalloutViewed } from '../trackers/fixed-rate';

/**
 * Fires one `fixed_rate_callout_viewed` impression per mount — the denominator
 * for the callout's `fixed_rate_app_clicked` (`source: 'market_callout'`).
 *
 * Call this from a component mounted outside `MarketPageLayout`, not from the
 * callout itself: the layout swaps between its desktop and mobile branches on a
 * post-hydration media query, so a callout-local hook remounts on every resize
 * across the breakpoint. The ref keeps it to one fire per mount, StrictMode's
 * double-invoke included.
 */
export const useTrackFixedRateCalloutViewed = (chainId, marketId) => {
  const $ = _c(4);
  const tracked = useRef(false);
  let t0;
  let t1;
  if ($[0] !== chainId || $[1] !== marketId) {
    t0 = () => {
      if (tracked.current) {
        return;
      }
      tracked.current = true;
      trackFixedRateCalloutViewed({
        chainId,
        marketId: marketId.toLowerCase()
      });
    };
    t1 = [chainId, marketId];
    $[0] = chainId;
    $[1] = marketId;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};